import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import { Button, Modal } from 'antd';
import { ReactComponent as CrossSVG } from '../../../assets/sightx-icons/svg/x-close.svg';
import { ReactComponent as CautionSVG } from '../../../assets/sightx-icons/svg/sx-exclamation-triangle.svg';
import styles from './index.module.scss';

interface DeleteModalProps {
  title: string;
  description: string;
  onProceed: () => void;
  onCancel: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = (props) => {
  return (
    <Modal
      visible
      onCancel={props.onCancel}
      className={styles.modal}
      footer={null}
      width={400}
      closeIcon={<Icon className={styles.closeIcon} component={CrossSVG} />}
    >
      <div className={styles.icon}>
        <Icon className={styles.dangerIcon} component={CautionSVG} />
      </div>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.description}>{props.description}</div>
      <div className={styles.footer}>
        <Button type="default" className={styles.cancelButton} onClick={props.onCancel}>Cancel</Button>
        <Button type="primary" className={styles.proceedButton} onClick={props.onProceed}>Proceed</Button>
      </div>
    </Modal>
  );
};
